import { useEffect, useState } from "react";
// REDUX
import { useGetAllKeysQuery } from "../../redux/keys/keysAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";

export default function useGetAllKeys() {
	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [keys, setKeys] = useState<any[]>([]);
	const [token, setToken] = useState<string | null>(null);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isFetching } = useGetAllKeysQuery(
		{ token },
		{ skip: !token, refetchOnMountOrArgChange: false }
	);

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setKeys(data.data);
		}
	}, [data]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		keys,
		isLoadingGetAllKeys: isLoading || isFetching,
	};
}
